import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import history from '../../history';
import routes from '../../utils/routes';

import AddQuestionPresentation from './add-question-presentation';

import {
    asyncCreateQuestion,
    changeSuccessAddQuestion,
} from './add-question.actions';

class AddQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            options: [],
            titleOption: '',
            checkedOptionCorrect: false,
            hasCorrect: '',
            hasOption: false,
            hasNewQuestion: false,
            optionsValid: false,
            optionsValidToAddOptions: false,
            editMode: false,
            originalOption: {},
            editTitleOption: '',
            checkedCorrectOption: false,
        };
    }

    componentDidUpdate(prevProps) {
        const { successAddQuestion, changeSuccessAddQuestion } = this.props;

        if (
            prevProps.successAddQuestion !== successAddQuestion &&
            successAddQuestion
        ) {
            this.setState({
                title: '',
                options: [],
                titleOption: '',
                checkedOptionCorrect: false,
                hasCorrect: '',
                hasOption: false,
                hasNewQuestion: false,
            });
            changeSuccessAddQuestion(false);
        }
    }

    componentWillUnmount() {
        changeSuccessAddQuestion(false);
    }

    checkOptionsValid(options) {
        let optionsValid = false,
            optionsValidToAddOptions = false;
        const validOptions = options;
        const hasOptionCorrectIndex = options.findIndex(
            option => option.correct,
        );
        if (
            validOptions.length >= 2 &&
            validOptions.length <= 10 &&
            hasOptionCorrectIndex >= 0
        ) {
            optionsValid = true;
        }

        if (validOptions.length < 10) {
            optionsValidToAddOptions = true;
        }
        this.setState({
            optionsValid: optionsValid,
            optionsValidToAddOptions: optionsValidToAddOptions,
        });
    }

    handleInputText(target) {
        const { options } = this.state;
        let newHasOption = false;
        if (target.name === 'titleOption') {
            const indexTitleOptionEqual = options.findIndex(
                option => (option.title).trim().toUpperCase() === (target.value).trim().toUpperCase(),
            );
            if (indexTitleOptionEqual >= 0) {
                newHasOption = true;
            }
        }

        this.setState({ [target.name]: target.value, hasOption: newHasOption });
    }

    handleItemsOptionQuestion(question) {
        const options = this.state.options;
        const findIndex = options.findIndex(
            item => item.title === question.title,
        );
        if (options.length < 10 && findIndex < 0) {
            const serializeOptions = options.map(option => ({
                ...option,
                correct: question.correct ? false : option.correct,
            }));
            const newOptions = [...serializeOptions, question];
            const itemCorrectIndex = newOptions.findIndex(item => item.correct);
            const hasItemCorrect = itemCorrectIndex >= 0;

            if (hasItemCorrect) {
                this.setState({ hasCorrect: true });
            } else {
                this.setState({ hasCorrect: false });
            }

            this.checkOptionsValid(newOptions);
            this.setState({
                options: newOptions,
                titleOption: '',
                checkedOptionCorrect: false,
            });
        }
    }

    handleRemoveItemsOptionQuestion(title) {
        const options = this.state.options;
        const newOptions = options.filter(item => item.title !== title);
        if (newOptions.find(item => item.correct)) {
            this.setState({ hasCorrect: true });
        } else {
            this.setState({ hasCorrect: false });
        }
        this.checkOptionsValid(newOptions);
        this.setState({
            options: [...newOptions],
            titleOption: '',
            checkedOptionCorrect: false,
        });
    }

    handleSelectCorrectOptionQuestion(title) {
        const options = this.state.options;
        options.map(item => {
            if (item.title === title) {
                item.correct = true;
            } else {
                item.correct = false;
            }
        });
        if (options.find(item => item.correct)) {
            this.setState({ hasCorrect: true });
        } else {
            this.setState({ hasCorrect: false });
        }
        this.checkOptionsValid(options);
        this.setState({ options: [...options] });
    }

    handleAddQuestion({ question, options, hasNewQuestion }) {
        this.props.asyncCreateQuestion({ question, options, hasNewQuestion });
    }

    gotoBack() {
        history.push(routes.QUESTIONS_DATABASE);
    }

    enableEditMode({ title, correct }) {
        this.setState({
            editMode: true,
            originalOption: {
                title: title,
                correct: correct,
            },
            editTitleOption: title,
            checkedCorrectOption: correct,
        });
    }

    saveOptionEditMode({ title, correct }) {
        const { originalOption, options } = this.state;
        if (Object.keys(originalOption).length > 0) {
            const serializeOptions = options.map(option => {
                if (originalOption.title === option.title) {
                    return { ...option, title, correct };
                }

                return {
                    ...option,
                    correct: correct ? false : option.correct,
                };
            });

            this.setState({
                options: serializeOptions,
                editMode: false,
                originalOption: {},
                editTitleOption: '',
                checkedCorrectOption: false,
            });
        }
    }

    disableEditMode() {
        this.setState({
            editMode: false,
            originalOption: {},
            editTitleOption: '',
            checkedCorrectOption: false,
        });
    }

    render() {
        const {
            title,
            options,
            titleOption,
            checkedOptionCorrect,
            hasCorrect,
            hasOption,
            hasNewQuestion,
            optionsValid,
            optionsValidToAddOptions,
            editMode,
            editTitleOption,
            checkedCorrectOption,
        } = this.state;
        const { loading } = this.props;

        return (
            <AddQuestionPresentation
                hasNewQuestion={hasNewQuestion}
                onCancel={this.gotoBack}
                handleSelectCorrectOptionQuestion={this.handleSelectCorrectOptionQuestion.bind(
                    this,
                )}
                handleRemoveItemsOptionQuestion={this.handleRemoveItemsOptionQuestion.bind(
                    this,
                )}
                handleAddQuestion={this.handleAddQuestion.bind(this)}
                hasCorrect={hasCorrect}
                title={title}
                handleInputText={this.handleInputText.bind(this)}
                handleItemsOptionQuestion={this.handleItemsOptionQuestion.bind(
                    this,
                )}
                options={options}
                titleOption={titleOption}
                checkedOptionCorrect={checkedOptionCorrect}
                hasOption={hasOption}
                loading={loading}
                optionsValid={optionsValid}
                optionsValidToAddOptions={optionsValidToAddOptions}
                editMode={editMode}
                editTitleOption={editTitleOption}
                checkedCorrectOption={checkedCorrectOption}
                enableEditMode={this.enableEditMode.bind(this)}
                disableEditMode={this.disableEditMode.bind(this)}
                saveOptionEditMode={this.saveOptionEditMode.bind(this)}
            />
        );
    }
}

const mapStateToProps = ({ addQuestion, onlineTests }) => ({
    successAddQuestion: addQuestion.successAddQuestion,
    loading: onlineTests.loading,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            asyncCreateQuestion,
            changeSuccessAddQuestion,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(AddQuestion);



// WEBPACK FOOTER //
// ./src/components/add-question/add-question.js